<template>
	<v-container>
		<div class="display-2 mb-7 mt-5 font-weight-thin" color="primary">
			{{ $tc("entities.resource.title", 2) }}
		</div>

		<alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
		<btn-a
			rounded
			color="primary"
			@click="editItem"
			:access="$access.resource.edit"
		>
			<v-icon>mdi-plus</v-icon>
		</btn-a>
		<table-grid
			:headers="headers"
			:items="items"
			:loading="loadingTable"
			:loadingAction="loadingDialog"
			:actions="actions"
			:page="pagination.page"
			:pageLength="lengthPaginationComp"
			@input="pagination.page = $event"
			@search="searchTable"
		/>

		<dialog-d
			ref="dialogEdit"
			:title="$tc('entities.resource.title')"
			:deleteButton="itemSelected && itemSelected.id"
			@confirm="saveItemCustom(itemSelected, $refs.form.isValid())"
			@delete="deleteItem(itemSelected, true)"
			:loading="loadingDialog"
			:accessConfirm="$access.resource.edit"
			:accessDelete="$access.resource.delete"
			:alert="form.alert"
		>
			<resourceForm
				ref="form"
				v-model="itemSelected"
				:itemSelected="itemSelected"
				:resources="resources"
				:environments="environments"
				:stageTypes="stageTypes"
				@search="handleSearch"
			/>
		</dialog-d>
	</v-container>
</template>

<script>
	import resourceService from "@/services/resourceService.js";
	import environmentService from "@/services/environmentService.js";
	import resourceForm from "../components/forms/resources/resourceForm";
	import pageListMixing from "../mixins/pageLists/pageListMixing.js";
	import stageTypeService from "@/services/stageTypeService.js";
	export default {
		mixins: [pageListMixing],
		components: { resourceForm },

		data() {
			return {
				apiController: "resource",
				entityService: resourceService,
				searchFields: ["code", "description", "sector", "type"],
				searchResource: '',
				resources: [],
				stageTypes: [],
				environments: [],
				headers: [
					{
						text: this.$t("entities.resource.props.code"),
						align: "left",
						sortable: false,
						value: "code",
					},
					{
						text: this.$t("entities.resource.props.description"),
						align: "left",
						sortable: false,
						value: "description",
					},
					{
						text: this.$t("entities.resource.props.environmentId"),
						align: "left",
						sortable: false,
						value: "environmentDesc",
					},
					{
						text: this.$t("table.actions"),
						value: "action",
						sortable: false,
						align: "right",
					},
				],
				actions: [
					{
						text: this.$t("edit"),
						icon: "mdi-pencil",
						handle: this.editItem,
						access: [this.$access.resource.edit, this.$access.resource.show],
					},
					{
						text: this.$t("delete"),
						icon: "mdi-delete",
						handle: this.deleteItem,
						access: this.$access.resource.delete,
					},
				],
			};
		},
		watch: {
			async itemSelected() {
				await this.getResources();
				await this.getStageTypes();
			},
		},
		methods: {
			async getModelDefault() {
				return {
					environmentId: "",
					code: await this.getAutoInc(this.apiController),
					description: "",
					sector: "",
					type: "",
					resourceRestIds: [],
					customFields: {},
				};
			},
			async saveItemCustom(item, formIsValid) {
				console.log("ITEM >>> ", item)
				await this.saveItem(item, formIsValid);
				await this.getResources();
			},
			async getItems() {
				this.loadingTable = true;
				let res =
					this.search && this.search.length > 0
						? await this.entityService.search(
								this.searchFields,
								this.search,
								this.pagination.page,
								this.pagination.limit
						  )
						: await this.entityService.getAll(
								this.pagination.page,
								this.pagination.limit
						  );

				if (res.success) {
					this.items = res.data.data;
					this.pagination.total = res.data.total;
					await this.getEnvironments();

					this.items.forEach((i) => {
						let env = this.environments.filter(
							(e) => e.id == i.environmentId
						)[0];
						i.environmentDesc = env ? env.description : "";
					});
				} else {
					this.errorNotification(res.data);
				}

				this.loadingTable = false;
			},
			async getEnvironments() {
				let res = await environmentService.getAll();
				if (res.success) this.environments = res.data.data;
			},
			async getResources() {
				let res = await this.entityService.getAll(1, 1000000) //this.$http.get("resource");
				if (res.success) this.resources = res.data.data;
			},
			handleSearch(value){
				this.searchResource = value
			},
			async getStageTypes() {
				let res = await stageTypeService.getAll();
				if (res.success) this.stageTypes = res.data.data;
			},
		},
		async mounted() {
			await this.getItems();
		},
	};
</script>
